<template>
    <div class="box">
        <div class="content" :style="{backgroundImage: `url(${bgUrl})`}">
            <!-- 标题 -->
            <topComponent title="招聘活动数据"></topComponent>
            <div  class="date-picker flex_r">
                <el-date-picker
                        class="date-picker-item"
                        @change="datePackerChange"
                        v-model="startData"
                        placeholder="开始日期"
                >
                </el-date-picker>
                <span class="date-picker-space"> 至 </span>
                <el-date-picker
                        class="date-picker-item"
                        @change="datePackerChange"
                        v-model="endData"
                        placeholder="结束日期"
                >
                </el-date-picker>
            </div>


            <el-row :gutter="10">
                <!-- 左边部分 -->
                <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
                    <div class="left">
                        <div class="block">
                            <img src="../assets/image/line.png" class="line_animation"/>
                            <div class="title">累计报名企业数</div>
                            <div class="zhe" ref="signup"></div>
                            <div class="zhu_box">
                                <el-row :gutter="5">
                                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                        <div class="title-small">空双报名企业数</div>
                                        <div class="zhu" ref="signupKongShuang"></div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                    <div class="title-small">线下双选报名企业数</div>
                                    <div class="zhu" ref="signupShuangXuan"></div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                        <div class="block">
                            <img  src="../assets/image/line.png" class="line_animation"/>
                            <div class="title">累计参会企业数</div>
                            <div class="zhe" ref="attend"></div>
                            <div class="zhu_box">
                                <el-row :gutter="5">
                                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                        <div class="title-small">空双参会企业数</div>
                                        <div class="zhu" ref="attendKongShuang"></div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                    <div class="title-small">线下双选参会企业数</div>
                                    <div class="zhu" ref="attendShuangXuan"></div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                        <div class="block">
                            <img  src="../assets/image/line.png" class="line_animation"/>
                            <div class="title">线下宣讲会场次</div>
                            <div class="zhe" ref="session"></div>
                            <div class="zhu_box">
                                <el-row :gutter="5">
                                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                        <div class="title-small">线下宣讲会报名企业数</div>
                                        <div class="zhu" ref="sessionSignup"></div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                    <div class="title-small">线下宣讲会参会企业数</div>
                                    <div class="zhu" ref="sessionAttend"></div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                </el-col>
                <!-- 中间部分 -->
                <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                    <el-row>
                        <el-col :span='8'>
                            <div class="title-large">线下双选会场次</div>
                            <div class="number">{{dataAll.milkround_count}}</div>
                        </el-col>
                        <el-col :span='8'>
                            <div class="title-large">空双场次</div>
                            <div class="number">{{dataAll.air_milkround_count}}</div>
                        </el-col>
                        <el-col :span='8'>
                            <div class="title-large">线下宣讲会场次</div>
                            <div class="number">{{dataAll.campustalk_count}}</div>
                        </el-col>
                    </el-row>
                    <div class="middle">
                        <!-- 线下双选会 -->
                        <div class="title"><img src="../assets/image/activity/back-title.png" alt=""><div>线下双选会</div></div>
                        <div class="numbers_box">
                            <el-row :gutter="10">
                                <el-col :xs="7" :sm="7" :md="7" :lg="6" :xl="6">
                                    <div class="circular">
                                        <img src="../assets/image/activity/back-circular.png" alt="">
                                        <img class="img" src="../assets/image/activity/back-icon1.png" alt="">
                                    </div>
                                </el-col>
                                <el-col :xs="5" :sm="5" :md="5" :lg="6" :xl="6">
                                    <div class="numbers">
                                        <p>累计预约学生数</p>
                                        <p class="n color_one">{{dataAll.milkround_student_apply_count}}</p>
                                    </div>
                                </el-col>
                                <el-col :xs="7" :sm="7" :md="7" :lg="6" :xl="6">
                                    <div class="circular">
                                        <img src="../assets/image/activity/back-circular.png" alt="">
                                        <img class="img" src="../assets/image/activity/back-icon2.png" alt="">
                                    </div>
                                </el-col>
                                <el-col :xs="5" :sm="5" :md="5" :lg="6" :xl="6">
                                <div class="numbers">
                                        <p>累计签到学生数</p>
                                        <p class="n color_two">{{dataAll.milkround_student_signin_count}}</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <!-- 空中双选会 -->
                        <div class="title"><img src="../assets/image/activity/back-title.png" alt=""><div>空中双选会</div></div>
                        <div class="numbers_box">
                            <el-row :gutter="10">
                                <!--<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">-->
                                    <!--<div class="circular padding">-->
                                        <!--<img src="../assets/image/activity/back-circular.png" alt="">-->
                                        <!--<div class="middle_number">-->
                                            <!--<p class="n color_one">{{dataAll.air_milkround_student_apply_count}}</p>-->
                                            <!--<p>累计参与学生数</p>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</el-col>-->

                                <el-col :xs="7" :sm="7" :md="7" :lg="6" :xl="6">
                                    <div class="circular">
                                        <img src="../assets/image/activity/back-circular.png" alt="">
                                        <img class="img" src="../assets/image/activity/back-icon1.png" alt="">
                                    </div>
                                </el-col>
                                <el-col :xs="5" :sm="5" :md="5" :lg="6" :xl="6">
                                    <div class="numbers">
                                        <p>累计参与学生数</p>
                                        <p class="n color_one">{{dataAll.air_milkround_student_participate_count}}</p>
                                    </div>
                                </el-col>

                                <el-col :xs="7" :sm="7" :md="7" :lg="6" :xl="6">
                                    <div class="circular">
                                        <img src="../assets/image/activity/back-circular.png" alt="">
                                        <img class="img" src="../assets/image/activity/back-icon2.png" alt="">
                                    </div>
                                </el-col>
                                <el-col :xs="5" :sm="5" :md="5" :lg="6" :xl="6">
                                    <div class="numbers">
                                        <p>累计简历投递量</p>
                                        <p class="n color_two">{{dataAll.air_milkround_student_delivery_count}}</p>
                                    </div>
                                </el-col>



                                <!--<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">-->
                                    <!--<div class="circular padding">-->
                                        <!--<img src="../assets/image/activity/back-circular.png" alt="">-->
                                        <!--<div class="middle_number">-->
                                            <!--<p class="n color_three">{{dataAll.air_milkround_student_delivery_count}}</p>-->
                                            <!--<p>累计简历投递量</p>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</el-col>-->
                            </el-row>
                        </div>
                        <!-- 宣讲会 -->
                        <div class="title"><img src="../assets/image/activity/back-title.png" alt=""><div>宣讲会</div></div>
                        <div class="numbers_box">
                            <el-row :gutter="10">
                                <el-col :xs="7" :sm="7" :md="7" :lg="6" :xl="6">
                                    <div class="circular">
                                        <img src="../assets/image/activity/back-circular.png" alt="">
                                        <img class="img" src="../assets/image/activity/back-icon1.png" alt="">
                                    </div>
                                </el-col>
                                <el-col :xs="5" :sm="5" :md="5" :lg="6" :xl="6">
                                    <div class="numbers">
                                        <p>累计预约学生数</p>
                                        <p class="n color_one">{{dataAll.campustalk_student_apply_count}}</p>
                                    </div>
                                </el-col>
                                <el-col :xs="7" :sm="7" :md="7" :lg="6" :xl="6">
                                    <div class="circular">
                                        <img src="../assets/image/activity/back-circular.png" alt="">
                                        <img class="img" src="../assets/image/activity/back-icon2.png" alt="">
                                    </div>
                                </el-col>
                                <el-col :xs="5" :sm="5" :md="5" :lg="6" :xl="6">
                                <div class="numbers">
                                        <p>累计签到学生数</p>
                                        <p class="n color_two">{{dataAll.campustalk_student_signin_count}}</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </el-col>
                <!-- 右边部分 -->
                <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
                    <div class="right">
                        <div class="block large">
                            <img src="../assets/image/activity/line-go.png" class="line_animation_large"/>
                             <img class="backNature" src="../assets/image/activity/back-charts.png" alt="">
                            <div class="title">参会企业行业分布</div>
                            <div id="industry" ref="industry"></div>
                            <div class="title">参会企业性质分析</div>
                            <div id="nature" ref="nature"></div>
                        </div>
                        <div class="block small">
                            <div class="background"><img src="../assets/image/activity/back-top-right.png" alt=""></div>
                            <el-row style="margin-top:8%;">
                                <el-col :xs="12" :sm="12" :md="24" :lg="12" :xl="12">
                                    <div class="small-title"><img src="../assets/image/activity/back-title.png" alt=""><div>累计职位数</div></div>
                                    <div class="small-number color_two">{{dataAll.position_count}}</div>
                                </el-col>
                                <el-col :xs="12" :sm="12" :md="24" :lg="12" :xl="12">
                                    <div class="small-title">累计岗位数</div>
                                    <div class="small-number color_three">{{dataAll.intent_count}}</div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import {ref,onMounted} from 'vue'
    import {initChartsZhe,initChartsZhu,initChartsSanZhu,initChartsCircular} from '../public/activityChart';
    import basicApi from '../public/http/index';
    import {ElDatePicker,ElMessage} from 'element-plus'

    export default {
        name: "activity",
        setup(){
			var bgUrl = "url(\"../assets/image/border_default_bg_l.png\")";
			let backgroundJson =   localStorage.getItem('background');
			if(backgroundJson){
			    let background = JSON.parse(backgroundJson);
			    if(background.milk){
                    bgUrl = background.milk;
                }
			}

            const signup=ref('signup');
            const signupKongShuang=ref('signupKongShuang');
            const signupShuangXuan=ref('signupShuangXuan');
            const attend=ref('attend');
            const attendKongShuang=ref('attendKongShuang');
            const attendShuangXuan=ref('attendShuangXuan');
            const session=ref('session');
            const sessionSignup=ref('sessionSignup');
            const sessionAttend=ref('sessionAttend');
            const industry=ref('industry');
            const nature=ref('nature');
            let dataAll=ref([]);
            let startData = ref('');
            let endData = ref('');
            onMounted(()=>{
                getData();
            })
            const getData = (e) => {
                let data = {}
                if(startData.value && endData.value ) {
                    let startyear =  startData.value.getFullYear();  // 获取完整的年份(4位,1970)
                    let startMonth = startData.value.getMonth()+1;  // 获取月份(0-11,0代表1月,用的时候记得加上1)
                    let startDay = startData.value.getDate();  // 获取日(1-31)

                    let endyear =  endData.value.getFullYear();  // 获取完整的年份(4位,1970)
                    let endMonth = endData.value.getMonth()+1;  // 获取月份(0-11,0代表1月,用的时候记得加上1)
                    let endDay = endData.value.getDate();  // 获取日(1-31)

                    data = {
                        start_time:startyear+'-'+ startMonth+'-' +startDay,
                        end_time:endyear+'-'+endMonth+'-'+ endDay
                    }
                }
                basicApi.get_screen_milk(data).then(res=>{
                    dataAll.value=res.data
                    console.log(res)
                    let signupChart = initChartsZhe(signup.value,['#9EE4F8','#01EEDE'],dataAll.value.all_milkround_apply_list)
                    let signupKongShuangChart = initChartsZhu(signupKongShuang.value,['#081f55','#A6EDFF','#9ce6f9'],dataAll.value.air_milkround_apply_list)
                    let signupShuangXuanChart = initChartsZhu(signupShuangXuan.value,['#081f55','#A6EDFF','#9ce6f9'],dataAll.value.milkround_apply_list)
                    let attendChart = initChartsZhe(attend.value,['#9EE4F8','#5AFF24'],dataAll.value.all_milkround_participate_list)
                    let attendKongShuangChart = initChartsZhu(attendKongShuang.value,['#0a253e','#5AFF24','#9bf6ac'],dataAll.value.air_milkround_participate_list)
                    let attendShuangXuanChart = initChartsZhu(attendShuangXuan.value,['#0a253e','#5AFF24','#9bf6ac'],dataAll.value.milkround_participate_list)
                    let sessionChart = initChartsZhe(session.value,['#9EE4F8','#EF585D'],dataAll.value.campustalk_list)
                    let sessionSignupChart = initChartsZhu(sessionSignup.value,['#432760','#EF585D','#f79c9e'],dataAll.value.campustalk_apply_list)
                    let sessionAttendChart = initChartsZhu(sessionAttend.value,['#432760','#EF585D','#f79c9e'],dataAll.value.campustalk_participate_list)
                    let industryChart = initChartsSanZhu(industry.value, (dataAll.value.industry_list || []).sort((a, b) => b.count - a.count))
                    let natureChart = initChartsCircular(nature.value, (dataAll.value.employer_type_list || []).sort((a, b) => b.count - a.count))
                    window.onresize=function(){
                        if(signupChart){signupChart.resize()}
                        if(signupKongShuangChart){signupKongShuangChart.resize()}
                        if(signupShuangXuanChart){signupShuangXuanChart.resize()}
                        if(attendChart){attendChart.resize()}
                        if(attendKongShuangChart){attendKongShuangChart.resize()}
                        if(attendShuangXuanChart){attendShuangXuanChart.resize()}
                        if(sessionChart){sessionChart.resize()}
                        if(sessionSignupChart){sessionSignupChart.resize()}
                        if(sessionAttendChart){sessionAttendChart.resize()}
                        if(industryChart){industryChart.resize()}
                        if(natureChart){natureChart.resize()}
                    }
                })
            }
            const datePackerChange = (e) => {
                if(startData&&endData){
                    if(startData.value && endData.value){
                        if((endData.value - startData.value) >( 86400000 * 366)){
                            ElMessage.error('时间跨度不能超过一年！')
                            return
                        }
                        getData()
                    }
                }
            }
            return{dataAll,signup,signupKongShuang,signupShuangXuan,attend,attendKongShuang,attendShuangXuan,session,sessionSignup,sessionAttend,industry,nature,bgUrl,
                startData,
                endData,
                datePackerChange
            }
        },
        data(){
            return{}
        }
    }
</script>

<style scoped>
img{
    width:100%;
}
.box{
    width:100%;
    height:100vh;
    box-sizing:border-box;
    -moz-box-sizing:border-box; /* Firefox */
    -webkit-box-sizing:border-box; /* Safari */
    overflow: hidden;
}
.content {
    height: 100%;
    background: url("../assets/image/page_default_bg.png") no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    padding:0 20px;
    box-sizing:content-box;
    overflow-y:auto;
    position: relative;
}
.left{
    width:100%;
    height:100%;
}
.block{
    width:100%;
    background: url("../assets/image/activity/box-border.png") no-repeat;
    background-size:100% 100%;
    margin-top:10px;
    position:relative;
    overflow: hidden;
    padding:20px;
    padding-bottom:0;
}
.block.large{
    background: url("../assets/image/activity/box-border-large.png") no-repeat;
    background-size:100% 100%;
    position:relative;
    padding-bottom:20px;
}
.backNature{
    position:absolute;
    bottom:-8%;
    left:10%;
    width:80%;
}
#industry,#nature{
    width:100%;
    min-height:310px;
}
.block.small{
    min-height:220px;
    background: url("../assets/image/activity/box-border-small.png") no-repeat;
    background-size:100% 100%;
    padding-bottom:20px;
}
.title{
    width:80%;
    height:30px;
    line-height:30px;
    border-left:2px solid #01EEDE;
    font-size:20px;
    color:#01EEDE;
    font-weight:bold;
    text-align:left;
    padding-left:10px;
    position:relative;
}
.title-large{
    font-size:24px;
    color:#84C7F7;
    font-weight:bold;
    margin-top:10px;
}
.number{
    font-size:44px;
    font-weight:900;
    background-image:linear-gradient(to right,#EFB758,#F8E98E);
    background-clip:text;
    -webkit-text-fill-color:transparent;
}
.middle{
    width:100%;
    padding:5% 5% 0 5%;
}
.circular{
    width:100%;
    height:auto;
    position:relative;
    padding:15% 0;
}
.circular .img{
    width:25%;
    position:absolute;
    top:38%;
    left:38%;
}
.numbers{
    width:100%;
    height:auto;
    padding:60px 0 0 15px;
}
.numbers p,.middle_number p{
    font-size:18px;
    color:#FFFFFF;
    margin-bottom:10px;
    text-align:left;
}
p.n{
    text-align:left;
    font-size:36px;
    font-weight:700;
}
.box .color_one{
    color:#EF585D;
}
.box .color_two{
    color:#01EEDE;
}
.box .color_three{
    color:#0091FF;
}
.middle_number{
    position:absolute;
    top:30%;
    left:12%;
}
.middle_number p{
    margin-bottom:0;
    text-align:center;
}
.middle_number p.n{
    height:50px;
}
.circular.padding{
    padding:10% 20% 10% 0;
}
.small-title{
    position:relative;
    font-size:20px;
    color:#fff;
    font-weight:bold;
    height:50px;
    line-height:50px;
}
.small-title img{
    position:absolute;
    top:-10px;
    left:0;
}
.small-title div,.title div{
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
}
.title div{
    margin-left:10px;
}
.title img{
    position:absolute;
    top:-10px;
    left:-10px;
    width:28%;
}
.small-number{
    font-size:44px;
    font-weight:900;
}
.numbers_box{
    padding:10px 0;
    min-height:200px;
}
@keyframes go {
    0%{
        left: -100px;
        opacity:0;
    }
    25%{
        left: calc(25% - 100px);
        opacity:0.5;
    }
    50%{
        left: calc(50% - 100px);
        opacity:1;
    }
    75%{
        left: calc(75% - 100px);
        opacity:0.5;
    }
    100%{
        left: calc(100% - 100px);
        opacity:0;
    }
}
@keyframes gogo {
    0%{
        left: -100px;
        opacity:0.2;
    }
    50%{
        left: calc(50% - 100px);
        opacity:1;
    }
    100%{
        left: calc(100% - 100px);
        opacity:0.2;
    }
}
.line_animation{
    animation:go 5s infinite linear;
    background-size:100px 3px;
    width: 100px;
    position: absolute;
    height: 3px;
    top: 0;
}
.line_animation_large{
    animation:gogo 4s infinite linear;
    background-size:100px 3px;
    width: 100px;
    position: absolute;
    height: 40px;
    top: -15px;
}
@keyframes opacity {
    0%{
        opacity:0.3
    }
    50%{
        opacity:1;
    }
    100%{
        opacity:0.3
    }
}
.background{
    position:absolute;
    top:0;
    right:0;
    width:60%;
    animation: opacity 3s infinite linear;
}
.zhe{
    width:120%;
    margin-left:-10%;
    margin-top:-30px;
    min-height:165px;
}
.title-small{
    font-size:16px;
    font-weight:bold;
    color:#01EEDE;
    text-align:left;
}
.zhu_box{
    margin-top:-30px;
}
.zhu{
    width:110%;
    margin-left:-5%;
    margin-top:-30px;
    min-height:160px;
}
@media screen and (max-width:1680px){
    .middle_number{
        left:7%;
    }
}
@media screen and (max-width:1440px){
    .numbers p,.middle_number p{
        font-size:15px;
    }
    p.n{
        font-size:30px;
    }
    .numbers{
        padding:40px 0 0 10px;
    }
    .middle_number p.n{
        height:40px;
    }
}
@media screen and (max-width:1366px){
    .title-large{
        font-size:20px;
    }
    .circular.padding{
        padding:5% 20% 5% 0;
    }
}
@media screen and (max-width:1080px){
    .title-large{
        font-size:24px;
    }
    .middle_number{
        left:16%;
    }
}
@media screen and (max-width:1000px){
    .title-large{
        font-size:16px;
    }
    .number{
        font-size:30px;
    }
    .middle_number{
        left:15%;
    }
    .numbers p,.middle_number p{
        font-size:18px;
    }
    p.n{
        font-size:38px;
    }
    .circular.padding{
        padding:0 20% 5% 0;
    }
    .numbers{
        padding:60px 0 0 10px;
    }
    .middle_number p.n{
        height:50px;
    }
}
@media screen and (max-width:768px){
    .title-large{
        font-size:15px;
    }
    .numbers p,.middle_number p{
        font-size:12px;
        margin-bottom:0;
    }
    p.n{
        font-size:28px;
    }
    .block.small{
        padding-bottom:0;
    }
    .numbers_box{
        min-height:160px;
    }
    .numbers{
        padding:20px 0 0 0;
    }
    .middle_number p.n{
        height:38px;
    }
    .middle_number{
        left:0;
        top:25%;
    }
    .content{
        height:100%;
        background: url("../assets/image/page_mobile_default_bg.png") no-repeat;
        background-size: 100% 100%;
        padding:0 15px;
    }
    .block.small{
        min-height:200px;
        margin-bottom:20px;
    }
    .small-number{
        font-size:36px;
    }
}
@media screen and (max-width:400px){
    .middle_number{
        left:-5%;
    }
}
</style>
